import React, { Component } from "react"
import PropTypes from "prop-types"
import { Table } from "elemental-react16"
import Price from "../Price/Price"
import { observer } from "mobx-react"
import shop from "shop/shop"
import cmsStore from "../../stores/cmsStore";
import CouponInput  from "./CouponInput";


@observer
class CartTotal extends Component {
  
  componentDidMount() {
    shop.cart.update()
  }
  
  render() {
    const { showTax, fluid, className = "" } = this.props
    let { sum, brutto, tax, size, sumDiscount } = shop.cart
    return (
      <Table style={{ maxWidth: `${fluid ? "100%" : "320px"}` }} className={`CartTotal ${className}`}>
        <thead>
        {cmsStore.config.plugin.coupons &&
        <tr>
          <td colSpan={2}>
            <CouponInput/>
          </td>
        </tr>}
        
        
        <tr>
          <td><strong>{translate( "Positionen" )}</strong></td>
          <td className="tr">{size}</td>
        </tr>
        
        <tr>
          <td><strong>{translate( "Zwischensumme" )}</strong></td>
          <td className="tr"><Price>{sum}</Price></td>
        </tr>
        
        {showTax &&
        <tr>
          <td><strong>{translate( "MwSt." )}</strong></td>
          <td className="tr"><Price>{tax}</Price></td>
        </tr>
        }
        
        {shop.config.useTaxNotice && <tr>
          <td colSpan={2}>
            <shop.config.useTaxNotice/>
          </td>
        </tr>}
        
        {showTax &&
        <tr>
          <td><strong>{translate( "Brutto" )}</strong></td>
          <td className="tr"><Price>{brutto}</Price></td>
        </tr>
        }
        
        
        {(shop.session.handId && !!sumDiscount) &&
        <React.Fragment>
          <tr className={"black-60 f5"}>
            <td>{translate( "Discount" )}</td>
            <td className="tr"><Price>{sumDiscount}</Price></td>
          </tr>
          
          <tr>
            <td><strong>{translate( "nach Rabatt" )}</strong></td>
            <td className="tr"><Price>{sum - sumDiscount}</Price></td>
          </tr>
        </React.Fragment>
        }
        
        </thead>
      </Table>
    )
  }
}

CartTotal.propTypes = {
  sum : PropTypes.number,
  size: PropTypes.number,
}

export default CartTotal



// WEBPACK FOOTER //
// ./src/components/Cart/CartTotal.js